import { useEffect, useState } from "react";
import { Modal, Button } from "@common";
import { formatMoney } from "@utils";

const FIELD_CLS =
  "w-full rounded-xl border border-palette-gray-divider bg-palette-gray-subtle px-3.5 py-2.5 text-sm text-palette-gray-primary focus:border-palette-indigo-ring focus:outline-none focus:ring-2 focus:ring-palette-indigo-border transition-colors";

function clean(name) {
  return (name || "").replace(/^(?:\s*Bank Balance\s*:\s*)+/i, "").trim();
}

// A funding transfer already exists for this associate-fee cell — instead of
// creating a duplicate, let the user move the existing transfer's date.
export default function MoveTransferDateModal({
  isOpen,
  onClose,
  transfer,
  onSave,
  saving = false,
  maxDate,
}) {
  const [date, setDate] = useState("");

  useEffect(() => {
    if (isOpen) setDate(transfer?.date || "");
  }, [isOpen, transfer]);

  const canSave = !!date && date !== transfer?.date;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Move transfer date"
      subtitle="A funding transfer already exists for this — update its date instead of creating a duplicate."
      size="sm"
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => onSave(date)} disabled={!canSave || saving}>
            {saving ? "Saving…" : "Move date"}
          </Button>
        </>
      }
    >
      <div className="space-y-4">
        <div className="rounded-xl border border-palette-gray-divider bg-palette-gray-subtle px-3.5 py-3 text-sm">
          <div className="font-semibold text-palette-gray-primary">
            {clean(transfer?.from_account_name)} → {clean(transfer?.to_account_name)}
          </div>
          <div className="text-palette-gray-secondary">
            {transfer ? formatMoney(transfer.amount) : ""} · {transfer?.status}
          </div>
        </div>
        <div>
          <label className="mb-1.5 block text-sm font-medium text-palette-gray-heading">Date</label>
          <input
            type="date"
            value={date}
            max={maxDate}
            onChange={(e) => setDate(e.target.value)}
            className={FIELD_CLS}
          />
        </div>
      </div>
    </Modal>
  );
}
